var map = {
	"./hearts.png": "43c7",
	"./icon-calories.png": "8567",
	"./icon-distance.png": "9e6e",
	"./icon-steps.png": "23a1",
	"./icon-time.png": "f231",
	"./sleeping.png": "6ffe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";